import { replySnippets } from '@markku/db'
import { REPLY_SNIPPET_SHORTCUT_PATTERN } from '@markku/utils'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectReplySnippetSchema = createSelectSchema(replySnippets).omit({
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export const insertReplySnippetSchema = createInsertSchema(replySnippets, {
  name: z.string().trim().min(1),
  shortcut: z
    .string()
    .trim()
    .toLowerCase()
    .regex(
      REPLY_SNIPPET_SHORTCUT_PATTERN,
      'Vain kirjaimia, numeroita ja viivoja',
    ),
  body: z.string().trim().min(1),
}).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
  usageCount: true,
  lastUsedAt: true,
})

export type ReplySnippet = z.infer<typeof selectReplySnippetSchema>
export type CreateReplySnippet = z.infer<typeof insertReplySnippetSchema>
